import React from 'react';
import Client from 'App/resources/Model/Client';
import SalesHistory from 'App/components/SalesHistory';

export default function HistoryColumn({
	account,
	createNewAccountRow
}: {
	account: Client;
	createNewAccountRow: boolean;
}) {
	const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
	const Component = hasGroupTreeVirtualizedList && !createNewAccountRow ? 'div' : 'td';

	return (
		<Component
			className={`DataSourceColumn history ${
				hasGroupTreeVirtualizedList && !createNewAccountRow ? 'align-items-center' : ''
			}`}
		>
			<SalesHistory entity={account} entityName={'client'} />
		</Component>
	);
}
